import React from 'react';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { Store } from './redux/Store';
import routes from './routes';
import { ErrorProvider } from "./contexts/ErrorContext";
import CustomAlertDialog from "./components/CustomAlertDialog";
import { UploadImageProvider } from "./contexts/UploadImageContext";
import { useLastSevenDaysOrderData } from './requests/order';
import useDashboard from './hooks/useDashboard';
import { useFeaturedProduct, useLastSavenDaysCustomer, useTopSellingProduct, useTotalLiveProductCount, useTotalOnlineRiderCount, useTotalProductCount, useTotalRiderCount, useTotalSellerCount, useTotalUser } from './requests/dashboard';
import { useGetRecentAddedVendor } from './requests/seller';



// initial query


const App = () => {
  const content = useRoutes(routes);

  // initial query 
  useLastSevenDaysOrderData({});
  useDashboard();
  useTopSellingProduct({});
  useFeaturedProduct({});

  // states

  useTotalProductCount({});
  useTotalLiveProductCount({});
  useTotalRiderCount({});
  useTotalOnlineRiderCount({});

  useTotalUser({});
  useTotalSellerCount({});
  useGetRecentAddedVendor({ limit: 5 });
  useLastSavenDaysCustomer()



  return (
    <Provider store={Store}>
      <SettingsProvider>
        <MatxTheme>
          <ErrorProvider>
            <UploadImageProvider>
              <CustomAlertDialog />
              <AuthProvider>{content}</AuthProvider>
            </UploadImageProvider>
          </ErrorProvider>
        </MatxTheme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
